import dayjs from "dayjs";

const dateUtils = {
  /**
   * Gets the formatted date or time from a given Date object.
   *
   * @param {Date} dateTime - The Date object to format.
   * @param {string} type - The type of format to return ('date' or 'time').
   * @returns {string} The formatted date or time.
   */
  getDateTime: (dateTime, type) => {
    if (!dateTime) return null;
    const [datePart, timePart] = dateTime.split(", ");
    const formattedDate = dayjs(datePart, "DD-MM-YYYY").format("DD-MM-YYYY");
    const formattedTime = dayjs(timePart, "hh:mm A").format("hh:mm A");
    if (type === "date") return formattedDate;
    if (type === "time") return formattedTime;

    return null;
  },

  formatDateToYYYMMDD: (dateString) => {
    if (dateString) {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    }
    return "";
  },
};

export default dateUtils;
